import React, { useEffect, useState } from 'react'

import * as R from 'ramda'
import i18n from 'i18next'

import Badge from '../../../UniformComponents/Badge'
import HoverInfo from '../../../UniformComponents/HoverInfo'

import './compound.scss'

const getSegmentStyle = (score, min, max, numberOfSegments) => {
    const segmentSize = (max - min) / numberOfSegments
    if (score < min + segmentSize) return 'error'
    if (numberOfSegments > 2 && score < min + 2 * segmentSize) return 'warning'
    return 'success'
}

const SubComponent = ({ name, score, min, max }, numberOfSegments, kpiType) => {
    if (R.isNil(min) || R.isNil(max)) return null

    const width = (score - min) / (max - min) * 100
    const type = getSegmentStyle(score, min, max, numberOfSegments)

    return (
        <div className="dependency">
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    {i18n.t(`dashboard.compound.${kpiType}.${name}.label`)}
                    {' '}
                    <HoverInfo
                        desc={i18n.t(`dashboard.compound.${kpiType}.${name}`)}
                        dir="right"
                    >
                        <i className="info-icon fa-solid fa-circle-question" />
                    </HoverInfo>
                </div>
                <div>
                    <span style={{ fontWeight: 700 }}>{score.toFixed(1)}</span> / <span style={{ fontWeight: 600, fontSize: '11px', color: '#8B99A7' }}>{max}</span>
                </div>
            </div>
            <div
                className="dependency__scale"
            >
                <span
                    className={`dependency__progress ${type}`}
                    style={{
                        width: `${width}%`,
                    }}
                />
            </div>
        </div>
    )
}

const Scale = ({ min, max, value }, left, right ) => {
    const leftOffset = (value - min) / (max - min) * 100
    return (
        <div
            className="scale"
        >
            <div
                className="scale__gradient"
            >
                <div
                    className="scale__pointer"
                    style={{
                        left: `calc(${leftOffset}% - 11px)`,
                    }}
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {Array.from({ length: max }, (_, i) => (
                    <span>{i + min}</span>
                ))}

            </div>
            <div
                className="scale__labels"
            >
                <span className="error">{left}</span>
                <span className="success">{right}</span>
            </div>
        </div>
    )
}

const segmentsECI = {
    error: 'Lagging',
    warning: 'Optimist',
    success: 'Accomplished',
}

const segmentsEEI = {
    error: 'Sceptic',
    warning: '',
    success: 'Optimist',
}

const Score = (value, widget, numberOfSegments) => {
    const { min, max, kpiType } = widget
    const type = getSegmentStyle(value, min, max, numberOfSegments)
    let position = 'Top'

    if (type === 'error') position = 'Bottom'
    else if (type === 'warning') position = 'Middle'

    return (
        <div
            className="score"
        >
            <div className="score__value">{value.toFixed(2)}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center' }}>
                <Badge
                    isRounded
                    type={type}
                >
                    {(kpiType === 'EEI' ? segmentsEEI : segmentsECI)[type]}
                </Badge>
                <div style={{ color: '#8B99A7', fontSize: '11px' }}>{position} 1/{numberOfSegments} of exhibitors</div>
            </div>
        </div>
    )
}

const CompoundKPI = ({ chartData, widget }) => {
    const { dependencies, kpiType } = widget
    const numberOfSegments = kpiType === 'EEI' ? 2 : 3
    const segments = (kpiType === 'EEI' ? segmentsEEI : segmentsECI)
    const value = chartData[0]?.value ?? 0
    return (
        <div
            className="compoundKPI"
        >
            {Score(value, widget, numberOfSegments)}
            {Scale({ min: 1, max: 5, value }, segments.error, segments.success)}
            <div
                style={{
                    fontWeight: 700,
                    color: '#8B99A7',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                }}
            >
                Average by question
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                }}
            >
                {dependencies.map((dependency) => (
                    SubComponent(dependency, numberOfSegments, kpiType)
                ))}
            </div>
        </div>
    )
}

export default CompoundKPI
